



























import Vue from "vue";
export default Vue.extend({
  props: {
    items: Array
  },
  methods: {
    getNextImg(index: number) {
      const len = this.items.length;
      const i = (index + 1) % len;
      return this.items[i];
    },
    getPrevImg(index: number) {
      const len = this.items.length;
      const i = (index + len - 1) % len;
      return this.items[i];
    }
  }
});
